import { render, staticRenderFns } from "./MatterDocumentForm.vue?vue&type=template&id=375d673d&"
import script from "./MatterDocumentForm.vue?vue&type=script&lang=js&"
export * from "./MatterDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterDocumentForm.vue?vue&type=style&index=0&id=375d673d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports